import { isEmail, isRequired, isRequiredContacts } from 'evcharging/app/validation/validators';

export default {
  [isRequired.name]: 'please fill this field',
  [isEmail.name]: 'please enter correct email',
  [isRequiredContacts.name]: 'fill out at least one of this form bellow',
};
